import React, { useEffect } from 'react';
import { generatePath, Navigate, Outlet, useParams } from 'react-router-dom';
import { useIsServiceOwner, useTraderServices } from '../../apis/service/use';
import { ROUTE_TRADING_SERVICE } from '../../routes';
import { useTranslation } from 'react-i18next';
import { useToast } from '../hooks/useToast';
import LayoutContentWrapper from '../../components/LayoutContentWrapper';

const ServiceOwnerWall: React.FC = () => {
  const { serviceId } = useParams();
  const traderServicesEndpoint = useTraderServices();
  const isOwner = useIsServiceOwner(serviceId);
  const { t } = useTranslation('error');
  const toast = useToast();

  useEffect(() => {
    if (isOwner === false) {
      toast.error(t('error.96'));
    }
  }, [isOwner, t]);

  if (traderServicesEndpoint.isLoading) {
    // means we're still loading
    return (
      <LayoutContentWrapper
        unmountOnRefetch
        endpoint={traderServicesEndpoint}
        content={() => null}
      />
    );
  }

  return isOwner === false ? (
    <Navigate
      to={generatePath(ROUTE_TRADING_SERVICE, {
        serviceId,
      })}
      replace
    />
  ) : (
    <Outlet />
  );
};

export default ServiceOwnerWall;
